import { useDestructiveDialog } from '@cast/design-system';

import { useDeleteEdgeConfigurationMutation } from 'hooks/mutations/omni';

import { EdgeConfigurationListItem } from '../types';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useDeleteEdgeConfigurationDialog = () => {
  const { cluster } = useCluster();
  const { mutate: deleteEdgeConfiguration } =
    useDeleteEdgeConfigurationMutation({
      clusterId: cluster.id,
    });

  const { openDialog } = useDestructiveDialog();

  return {
    openDeleteEdgeConfigurationDialog: (
      edgeConfiguration: EdgeConfigurationListItem
    ) => {
      openDialog({
        title: 'Are you sure you want to delete this edge configuration?',
        confirmButtonText: 'Delete',
        testId: 'delete-edge-configuration-dialog',
        onConfirm: () =>
          deleteEdgeConfiguration({
            edgeConfigurationId: edgeConfiguration.id!,
            edgeLocationId: edgeConfiguration.edgeLocationId!,
          }),
        slotProps: {
          cancelButton: { testId: 'cancel-delete-edge-configuration' },
          confirmButton: { testId: 'confirm-delete-edge-configuration' },
        },
      });
    },
  };
};
